export default __webpack_public_path__ + "static/landing_kr_light-1aa84f6ab4c4d0b98fabad94e49e6550.png";